import React, { useState, useEffect } from "react";
import { withRouter } from '../../common/withRouter';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DataDefinitionList,
  Notification,
  ButtonOBSOLETED,
  Message,
  Loader
} from "../../web.common";
import withApi from "../higherOrderComponents/withApi";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import { DisplayGuid, DisplayType } from "../items";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import { Divider, DetailsRightBar, NoLink, Action } from './DetailsRightBar';

const LockerInternal = (
  {
    api,
    match: {
      params: { lockerId },
    }
  }
) => {
  const initialCodeDataValue = { lockerId: null, date: null, duration: null, code: null };
  const [data, setData] = useState(null);
  const [isEditing, doEdit] = useState(null);
  const [lockerTypeMapped, setLockerTypeMapped] = useState(null);
  const [properties, setProperties] = useState([]);
  const [codesList, setCodesList] = useState(null);
  const [editedNotification, setNotification] = useState(null);
  const [codeDataInstallation, setCodeDataInstallation] = useState(initialCodeDataValue);
  const [isRemovingCode, setIsRemovingCode] = useState(false);
  const [isInstallingCode, setIsInstallingCode] = useState(false);
  const [alertedField, setAlertedField] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "30%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top",
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0",
  };

  const containerStyle = {
    width: "60%",
    margin: "auto",
    backgroundColor: "white",
    border: "1px solid #e5e5e5",
    padding: "1.2rem",
  };

  useEffect(() => {
    async function loadFromApi() {
      const locker = await api.lockers.getLockerById(lockerId);

      setData(locker.data);

      const lockerTypesResponse = await api.lockers.getLockerTypes();
      setLockerTypeMapped(
        lockerTypesResponse.data.map((x) => ({ value: x.key, label: x.value }))
      );

      getPropertiesByType(locker.data.lockerTypeId);
    }

    if (!data || !lockerTypeMapped) {
      loadFromApi();
    }
  }, [lockerTypeMapped]);

  const lookupFacility = async (inputValue) => {
    const response = await api.facilities.lookupByNameOrId(inputValue);
    return response;
  };

  const showAlert = (field) => {
    return (<div style={rowStyle}>
      <label for={field + '-alert'} style={formLabelStyle}></label>
      <span style={{ ...formSpanStyle, color: 'red', alignContent: 'center' }}>{field} is mandatory
      </span>
    </div>)
  };

  const dataFiltered = (obj) => {
    const filteredObj = Object.fromEntries(
      Object.entries(obj)
        .filter(([key, value]) =>
          properties.some(
            (item) => item.toLowerCase().trim() === key.toLowerCase().trim()
          )
        )
        .map(([key, value]) => {
          key = key == "randomCodeLenght" ? "CodeLength" : key;
          const firstUpper = key.charAt(0).toUpperCase();
          const capitalizedKey = firstUpper + key.slice(1);
          return [capitalizedKey, value];
        })
    );
    return {
      Id: obj.id,
      Name: obj.name,
      Facility: <>{obj.facilityName} - <DisplayGuid baseAnchor={`../facility`}>{obj.facilityId}</DisplayGuid></>,
      Type: <DisplayType>{obj.lockerType}</DisplayType>,
      ...filteredObj,
    };
  };

  const removeCode = async (reference) => {
    console.log(reference);
    console.log(lockerId);
    const response = await api.lockers.removeCode(lockerId, reference);
    if (response.success) {
      setNotification(new Message('success', 'Code removed successfully.'));
      var codes = await api.lockers.getInstalledCodes(lockerId);
      setCodesList(codes.data);
    } else {
      setNotification(new Message('error', `Code removal failed. ${response.message}`));
    }
    setIsRemovingCode(false);
  };

  const installCode = async (event) => {
    event.preventDefault();

    if (codeDataInstallation.code.length != data.randomCodeLenght) {
      const confirmation = confirm(`The code length is different from the code length set for the locker. Are you sure to install this code?`);
      if (!confirmation) {
        setIsInstallingCode(false);
        return;
      }
    }
    const validationResponse = validateForm(codeDataInstallation);

    if (validationResponse.success == false) {
      setNotification(new Message(validationResponse.type, validationResponse.message));
    } else {
      const date = codeDataInstallation.date;
      const duration = codeDataInstallation.duration;
      const code = codeDataInstallation.code;

      const response = await api.lockers.installCode(lockerId, date, duration, code);

      if (response.success) {
        setNotification(new Message('success', 'Code installed successfully.'));
      } else {  
        setNotification(new Message('error', `Installation failed. ${response.message}`));
      }

      setCodeDataInstallation(initialCodeDataValue);
      setIsInstallingCode(false);
      setCodesList(null);
    }
  };

  const validateForm = (propsToValidate) => {

    const emptyFields = [];
    let response = {
      success: false,
      type: 'error',
      message: ''
    };

    if (!propsToValidate.date) {
      emptyFields.push('Date');
    }
    if (!propsToValidate.duration) {
      emptyFields.push('Duration');
    }
    if (!propsToValidate.code) {
      emptyFields.push('Code');
    }

    if (emptyFields.length == 1) {
      response.message = `Unable to install the code. The ${emptyFields} field is mandatory.`
    } else if (emptyFields.length > 1) {
      response.message = `Unable to install the code. ${emptyFields.join(', ')} are mandatory.`
    } else {
      response.success = true;
      response.type = 'success';
    }

    return response;
  }


  const getPropertiesByType = async (typeId) => {
    const propertiesResponse = await api.lockers.getPropertiesByTypeId(typeId);
    setProperties(propertiesResponse.data);
  };

  const propertiesMapped =
    isEditing &&
    properties.map((x) => {
      const firstChar = x.charAt(0).toLowerCase();
      const propertyLowerFirst = firstChar + x.slice(1);
      return (
        <>
          <div style={rowStyle} key={x}>
            <label for={x} style={formLabelStyle}>
              {x.toLowerCase() == 'randomcodelenght' ? 'Code Length' : x}
            </label>
            <span style={formSpanStyle}>
              <input
                name={x}
                id={x}
                placeholder={x}
                value={isEditing[propertyLowerFirst]}
                required
                title={`${x} is mandatory`}
                onChange={({ target }) => {
                  console.log(target.value);
                  setAlertedField(null);
                  doEdit({
                    ...isEditing,
                    [propertyLowerFirst]: target.value,
                  });
                }}
                onBlur={({ target }) => {
                  if (!target.value || target.value.trim() === '') {
                    setAlertedField(x)
                  }
                }}
              />
            </span>
          </div>
          {alertedField == x ? showAlert(x) : null}
          <hr />
        </>
      );
    });

  const lockerData = data && (<React.Fragment>
    <DataDefinitionList
      listData={{
        ...dataFiltered(data),
        "": (
          <div>
            <br />
            <ButtonOBSOLETED
              type="submit"
              buttonContent="Edit"
              onClick={() => {
                doEdit({ ...data, facility: { value: data.facilityId, label: data.facilityName } });
              }}
            />
          </div>
        ),
      }}
      classNames={["detail-page-list"]}
    />
    <br />
    <br />
    {
      data.supportsCodeListing ?
        <React.Fragment>
          {
            codesList ? codesList == "loading" ?
              <React.Fragment>
                <br />
                <br />
                <Loader/>
              </React.Fragment> :
              codesList.codes.length == 0 ?
                <React.Fragment>
                  <br />
                  <br />
                  No codes installed
                </React.Fragment> :
                <React.Fragment>
                  {isRemovingCode && <Loader/>}
                  <>
                    <h3 className='main-page-subheader'>Code List</h3>
                    <br />
                    <div style={{ ...containerStyle, width: "90%" }}>
                      <table style={{ borderCollapse: 'separate', borderSpacing: '20px 10px', filter: isRemovingCode && 'blur(1px)' }}>
                        <thead>
                          <tr>
                            {codesList.columns.map((column) => <th>{column}</th>)}
                          </tr>
                        </thead>
                        <tbody>
                          {codesList &&
                            codesList.codes.map(
                              (code, x) => <tr
                                key={x} >{codesList.columns.map(
                                  (column, x) => <td key={x}>{code[column]}</td>)}<td>
                                  <button
                                    disabled={isRemovingCode}
                                    onClick={async () => {
                                      const result = confirm("Are you sure to remove this code ?");
                                      if (!result) {
                                        return;
                                      }
                                      setIsRemovingCode(true);
                                      removeCode(code[codesList.reference])
                                    }}>Remove Code</button></td></tr>)
                          }
                        </tbody>
                      </table>
                    </div>
                  </>
                </React.Fragment>
              : ""}
        </React.Fragment> : ""
    }
  </React.Fragment>);

  const lockerForm = isEditing && (<React.Fragment>
    <div style={containerStyle}>
      <div style={rowStyle}>
        <label for="name" style={formLabelStyle}>
          Name
        </label>
        <span style={formSpanStyle}>
          <input
            name="name"
            id="name"
            value={isEditing.name}
            placeholder="name"
            onChange={({ target }) =>
              doEdit({
                ...isEditing,
                name: console.log(target.value) || target.value,
              })
            }
          />
        </span>
      </div>
      <hr />
      <div style={rowStyle}>
        <label for="facility" style={formLabelStyle}>
          Facility
        </label>
        <span style={formSpanStyle}>
          <AsyncSelect
            className="react-select-filters-section"
            classNamePrefix="react-select-filters-section-prefix"
            defaultOptions
            value={isEditing.facility}
            cacheOptions
            onChange={(selection) =>
              doEdit({
                ...isEditing,
                facility: console.log(selection) || selection,
              })
            }
            loadOptions={async (inputValue) => lookupFacility(inputValue)}
          ></AsyncSelect>
        </span>
      </div>
      <hr />
      <div style={rowStyle}>
        <label for="type" style={formLabelStyle}>
          Type
        </label>
        <span style={formSpanStyle}>
          <ReactSelect
            className="react-select-filters-section"
            classNamePrefix="react-select-filters-section-prefix"
            value={lockerTypeMapped.filter(
              (x) => x.value == isEditing.lockerTypeId
            )}
            onChange={(selection) => {
              doEdit({
                ...isEditing,
                lockerTypeId:
                  console.log(selection) || selection.value,
              });
              getPropertiesByType(selection.value);
            }}
            options={lockerTypeMapped.filter((x) => x.value != 0)}
          ></ReactSelect>
        </span>
      </div>
      <hr />
      {propertiesMapped}
      <br />
      <br />
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          gap: "1.5rem",
        }}
      >
        <ButtonOBSOLETED
          type="submit"
          buttonContent="Save"
          onClick={async () => {
            const response = await api.lockers.updateLocker(isEditing);
            if (response.hasOwnProperty('success') && response.success === false) {
              setNotification(new Message('error', `Unable to update the locker. ${response.message}`));
              return;
            }
            const locker = await api.lockers.getLockerById(
              isEditing.id
            );
            setData(locker.data);
            doEdit(null);
          }}
        />
        <ButtonOBSOLETED
          buttonColor='gray'
          size='small'
          buttonContent="Cancel"
          onClick={async () => {
            doEdit(null);
          }}
        >Cancel</ButtonOBSOLETED>
      </div>
    </div>
  </React.Fragment>);

  const installCodeForm = data &&
     (<>
    <div style={containerStyle}>
        <div style={rowStyle}>
          <label for="date" style={formLabelStyle}>
            Date
          </label>
          <span style={formSpanStyle}>
          <input
            type="datetime-local"
            value={codeDataInstallation.date}
            onChange={({target}) => {
              console.log(target.value);
              setCodeDataInstallation({ ...codeDataInstallation, date: target.value == "" ? null : target.value })

            }}
          />
          </span>
        </div>
        <hr />
        <div style={rowStyle}>
          <label for="duration" style={formLabelStyle}>
            Duration In Minutes
          </label>
          <span style={formSpanStyle}>
            <input
              name="duration"
              id="duration"
              value={codeDataInstallation.duration}
              placeholder="duration"
              onChange={({ target }) =>
                setCodeDataInstallation({ ...codeDataInstallation, duration: console.log(target.value) || target.value })
              }
            />
          </span>
        </div>
        <hr />
        <div style={rowStyle}>
          <label for="code" style={formLabelStyle}>
            Code
          </label>
          <span style={formSpanStyle}>
            <input
              name="code"
              id="code"
              value={codeDataInstallation.code}
              placeholder="code"
              onChange={({ target }) =>
                setCodeDataInstallation({ ...codeDataInstallation, code: console.log(target.value) || target.value })
              }
            />
          </span>
        </div>
      </div>
      <br />
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          gap: "1.5rem",
        }}
      >
        <ButtonOBSOLETED
          disabled={isInstallingCode}
          type="submit"
          buttonContent="Install"
          onClick={async (e) => {
            setIsInstallingCode(true);
            await installCode(e);
          }}
        />
        <ButtonOBSOLETED
          buttonColor='gray'
          size='small'
          buttonContent="Cancel"
          onClick={async () => {
            setCodeDataInstallation(initialCodeDataValue);
          }}
        >Cancel</ButtonOBSOLETED>
      </div>
      {isInstallingCode && <Loader/>}
    </>);


  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle={`Locker details`}
            documentDescription={`Locker details`}
          />
          {data ? (
            <React.Fragment>
              <h2 className='main-page-header main-page-header-with-subheader'>
                Locker Details
              </h2>
              {codeDataInstallation.lockerId && <h5 className='main-page-subheader'>Install Code</h5>}
              <br />
              {codeDataInstallation.lockerId && installCodeForm}
              {(isEditing && !codeDataInstallation.lockerId) && lockerForm} 
              {(!codeDataInstallation.lockerId && !isEditing) && lockerData}
              <DetailsRightBar>
                <Divider>Links</Divider>
                <NoLink>None</NoLink>
                <Divider>Actions</Divider>
                {
                  (data && data.supportsCodeInstall && !isEditing) ? (
                    <Action action={async () => {
                      if (data.lockerType.toLowerCase().trim() != "nox") {
                        setNotification(new Message('error', 'It only works for Nox locker.'));
                        console.log('it only works for nox');
                        return;
                      }
                      setCodeDataInstallation({...codeDataInstallation, lockerId: data.id})
                    }}
                    >
                      Install Code
                    </Action>
                  ) : (<NoLink>None</NoLink>)
                }
                {
                  (data && data.supportsCodeListing && !isEditing && !codeDataInstallation.lockerId) && (
                    <Action action={async () => {
                      setCodesList("loading");
                      var codes = await api.lockers.getInstalledCodes(lockerId);
                      setCodesList(codes.data);
                    }}
                    >
                      Show Codes
                    </Action>
                  )
                }
              </DetailsRightBar>
            </React.Fragment>
          ) : 
            <Loader />
        }
      </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

const Locker = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(LockerInternal)
  )
);

Locker.requiresLogin = true;
Locker.propTypes = { isLoggedIn: PropTypes.bool };

export default Locker;
